var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('video',{ref:"player",attrs:{"playsinline":"","poster":_vm.posterUrl,"src":_vm.videoUrl,"width":_vm.width,"height":_vm.height},on:{"contextmenu":function($event){$event.preventDefault();}}})}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MiniPreviewVideoPlayer.vue?vue&type=template&id=232be8f4&
// module id = 1682
// module chunks = 5